import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-bmi',
  templateUrl: './cyclops-bmi.component.html',
  styleUrls: ['./cyclops-bmi.component.scss']
})
export class cyclopsBMIComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    
  }

}
